<template>
  <v-app id="calendar-app">
    <v-content>
      <Calendar :defaultType="defaultType"/>
    </v-content>
  </v-app>
</template>

<script>
import Calendar from './components/Calendar';

export default {
  name: 'App',

  components: {
    Calendar,
  },

  data: () => ({
    defaultType: 0
  }),
  created(){
    this.defaultType = parseInt(this.getAttributeValue('course-type'));
  },
  methods:{
    getAttributeValue(attributeName){
      return document.getElementsByTagName('course-calendar')[0].getAttribute('data-' + attributeName);
    }
  }

};
</script>
<style>
@import url("https://fonts.googleapis.com/css?family=Roboto:100,300,400,500,700,900");
#calendar-app {
  background: transparent;
}

#main {
  z-index: 2;
}

@media screen and (min-width: 600px) {
  .v-dialog:not(.v-dialog--fullscreen) {
    max-height: 60%
  }
}

input[type='text'], input[type='text']:focus {
  border: none;
  background: transparent;
  box-shadow: none;
}

legend {
  width: 0;
}
</style>
